import { toDate } from './timestampUtils';
import type { ITeamUpdatePost, ITeamUpdateReply } from '../types/TeamUpdate';

export type TeamUpdateUnreadActivity = {
  lastViewedAt?: { seconds?: number; nanoseconds?: number } | Date | null;
};

function activityTimeMs(value: TeamUpdateUnreadActivity['lastViewedAt']): number {
  if (!value) return 0;
  return toDate(value as Parameters<typeof toDate>[0])?.getTime() || 0;
}

function createdTimeMs(item: { createdAt?: Parameters<typeof toDate>[0] }): number {
  return toDate(item.createdAt)?.getTime() || 0;
}

/** Count posts by others created after the user last viewed the chat. */
export function countUnreadPosts(
  posts: ITeamUpdatePost[],
  currentUserId: string,
  lastViewedAt?: TeamUpdateUnreadActivity['lastViewedAt']
): number {
  if (!currentUserId || !posts.length) return 0;
  const baseline = activityTimeMs(lastViewedAt);
  return posts.filter(
    (post) => post.authorId !== currentUserId && createdTimeMs(post) > baseline
  ).length;
}

/** Count replies by others created after the user last viewed the chat. */
export function countUnreadRepliesSinceView(
  replies: ITeamUpdateReply[],
  currentUserId: string,
  lastViewedAt?: TeamUpdateUnreadActivity['lastViewedAt']
): number {
  if (!currentUserId || !replies.length) return 0;
  const baseline = activityTimeMs(lastViewedAt);
  return replies.filter(
    (reply) => reply.authorId !== currentUserId && createdTimeMs(reply) > baseline
  ).length;
}

export function totalUnreadFromPostsAndReplies(
  posts: ITeamUpdatePost[],
  replies: ITeamUpdateReply[],
  currentUserId: string,
  lastViewedAt?: TeamUpdateUnreadActivity['lastViewedAt']
): number {
  return (
    countUnreadPosts(posts, currentUserId, lastViewedAt) +
    countUnreadRepliesSinceView(replies, currentUserId, lastViewedAt)
  );
}
